{
  "url.connect": "/connect",
  "url.donate": "/donate",
  "url.community": "/community/{id}-{slug}",
  "url.menu.contact": "/contact",
  "url.menu.introduction": "/page/introduction",
  "url.menu.about": "/page/about",
  "url.menu.communities-list": "/communities-list",
  "url.menu.guides-list": "/guides-list",
  "url.menu.cgu": "/page/cgu",
  "url.menu.events": "/page/evenements"
}
